import { Timeout } from "@obg/ngx.core";

export interface TimeOffConfig {
	isTimeOffHidden: boolean;
	isCoolOffEnabled: boolean;
	showRegulationText: boolean;
}

export interface TimeOffContent {
	imageUrl: string;
	timeOffCaption: string;
	coolOffCta: string;
	coolOffCaption: string;
	timeOffPeriod: string;
	timeoutCta: string;
	timeoutRegulation: string;
}

export const enum Prefix {
	SelfExclusion = "self-exclusion",
	TimeOff = "time-off",
}

export interface TimeoutTranslation {
	key: string;
	translation: string;
}

export interface TimoutPeriod extends Timeout {
	key: string;
}

export const TIME_OFF_ALERT_ID = "TIME_OFF_ALERT_ID";
